import * as React from 'react';

import { Container } from '../../../../components/Container';
import { SIZE_16, SIZE_28, SIZE_240, SIZE_WIDE } from '../../../../constants/sizes';

export const renderFieldRow = ({ title, field }: { title: string, field: React.ReactNode }): React.ReactNode => (
  <Container padding={`${SIZE_16} ${SIZE_28}`} display="flex" backgroundColorHover="blue_hover">
    <Container
      width={SIZE_240}
      display="flex"
      alignItems="center"
      whiteSpace="nowrap"
    >
      {title}
    </Container>
    <Container width={SIZE_WIDE}>{field}</Container>
  </Container>
);
